import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
//import { AuthenticationService } from '@sharedV11/services/authentication/authentication.service';
import { Translator } from "@sharedV11/services/translator/translator.service";

@Injectable({
	providedIn: "root",
})
export class SnackbarInfoService {
	translation;
	constructor(
		private snackBar: MatSnackBar, //private autentificador: AuthenticationService,
		private translator: Translator
	) {
		this.initializeTranslate();
	}

  async initializeTranslate() {
    this.translation = this.translator.GetTranslations();
    this.translator.dataLanguage$.subscribe((data) => {
      if (data) {
        this.translation = this.translator.GetTranslations();
      }
    });
  }

	private static readonly API_MESSAGE_KEYS: Record<string, string> = {
		"No se han encontrado datos": "NoSeEncontraronDatos",
		"No se encontraron datos": "NoSeEncontraronDatos",
	};

	private static normalizeMessageTypo(msg: string): string {
		if (!msg || typeof msg !== "string") return msg;
		return msg.replace(/exitente/gi, "existente");
	}

	
	private coerceMessageToString(message: any): string {
		if (message == null || message === undefined) {
			return "";
		}
		if (typeof message === "string") {
			return message;
		}
		if (typeof message === "number" || typeof message === "boolean") {
			return String(message);
		}
		if (typeof message.message === "string" && message.message) {
			return message.message;
		}
		const err = message.error;
		if (typeof err === "string") {
			return err;
		}
		if (err && typeof err === "object") {
			if (typeof err.message === "string") {
				return err.message;
			}
			if (err.DescripcionMensaje != null) {
				return String(err.DescripcionMensaje);
			}
			if (err.mensaje != null) {
				return String(err.mensaje);
			}
		}
		try {
			return JSON.stringify(message);
		} catch {
			return "Error";
		}
	}

	openSnackBar(
		message: string | any,
		action: string,
		color: string,
		codigo?: any,
		durationToast = 2500
	) {
		let text = this.coerceMessageToString(message);

		if (codigo && codigo != "") {
			var cod = parseInt(codigo);
			//if (cod==-2) this.autentificador.logout();
			if (isNaN(cod)) {
				text = this.translation?.[codigo] ?? text;
			} else {
				text = this.translation?.["CodErr_" + cod] ?? text;
			}
		} else if (text && SnackbarInfoService.API_MESSAGE_KEYS[text.trim()]) {
			text = this.translation?.[SnackbarInfoService.API_MESSAGE_KEYS[text.trim()]] ?? text;
		}
		text = SnackbarInfoService.normalizeMessageTypo(text) as string;
		if (text)
			this.snackBar.open(text, action, {
				duration: durationToast,
				panelClass: [color],
				horizontalPosition: "center",
				verticalPosition: "top",
			});
	}
}
